import { Instagram, Facebook, Linkedin } from "lucide-react";
import { SOCIALS } from "../constants";
import { useLanguage } from "../i18n/LanguageContext";

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 1 0 15.69 16V8.76a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const ICONS = {
  instagram: Instagram,
  tiktok: TikTokIcon,
  facebook: Facebook,
  linkedin: Linkedin,
};

const SocialIcons = ({ size = "md" }) => {
  const { t } = useLanguage();
  const box = size === "lg" ? "h-12 w-12" : "h-10 w-10";
  const ic = size === "lg" ? "h-5 w-5" : "h-4 w-4";

  return (
    <div className="flex gap-3" data-testid="social-icons">
      {SOCIALS.map((s) => {
        const Icon = ICONS[s.icon];
        return (
          <a
            key={s.name}
            href={s.href}
            data-testid={s.testId}
            {...(s.live ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            aria-label={s.live ? `A&A MOTORS on ${s.name}` : `${s.name} — ${t("footer.socialPlaceholder")}`}
            title={s.live ? `A&A MOTORS on ${s.name}` : `${s.name} — ${t("footer.socialPlaceholder")}`}
            className={`flex ${box} items-center justify-center rounded-full border transition-all duration-300 ${
              s.live
                ? "border-gold/40 bg-gold/10 text-gold hover:bg-gold hover:text-[#08080A] hover:shadow-[0_0_24px_rgba(212,175,55,0.35)]"
                : "border-white/10 text-slate-500 hover:border-gold/50 hover:text-gold"
            }`}
          >
            <Icon className={ic} />
          </a>
        );
      })}
    </div>
  );
};

export default SocialIcons;
